import { MenuItem } from "./models/MenuItemModel.js";

const langCode = document.documentElement.lang;

const menuAccountItems: MenuItem[] =
    (
        langCode === "FR" ?
            [
                { text: "Mijn account", url: "/mon-compte/", isHeading: true, loggedIn: false },
                { text: "Bestellingen", url: "/mon-compte/commandes/", isHeading: false, loggedIn: true },
                { text: "Retourneren", url: "/mon-compte/retourner/", isHeading: false, loggedIn: true },
                { text: "Gegevens", url: "/mon-compte/coordonnees/", isHeading: false, loggedIn: true },
                { text: "Uitloggen", url: "/mon-compte/deconnexion/", isHeading: false, loggedIn: true },
                { text: "Inloggen", url: "/mon-compte/connexion/", isHeading: false, loggedIn: false }
            ]
            :
            [
                { text: "Mijn account", url: "/mijn-account/", isHeading: true, loggedIn: false },
                { text: "Bestellingen", url: "/mijn-account/bestellingen/", isHeading: false, loggedIn: true },
                { text: "Retourneren", url: "/mijn-account/mijn-retouren/", isHeading: false, loggedIn: true },
                { text: "Gegevens", url: "/mijn-account/gegevens/", isHeading: false, loggedIn: true },
                { text: "Uitloggen", url: "/mijn-account/uitloggen/", isHeading: false, loggedIn: true },
                { text: "Inloggen", url: "/mijn-account/inloggen/", isHeading: false, loggedIn: false }
            ]
    );

const translationList: Array<TranslationSite> = [];

type Translations =
    {
        //#region Util
        
        searchUrl?: string;
        loginUrl?: string;
        txtUtilShoppingCart?: string;
        txtUtilStep2?: string;
        txtUtilHome?: string;
        homeUrlLowerCaseTxt?: string,
        txtUtilSearch?: string;
        txtUtilShowCapitals?: string;
        txtUtilProductCapitals?: string;
        txtUtilProductsCapitals?: string;
        txtUtilShow?: string;
        txtUtilProduct?: string;
        txtUtilProducts?: string;
        pageText?: string;
        pageTitleText?: string;
        pageNumberText?: string;
        indexPositionText?: string;
        previousPageTitleText?: string;
        nextPageTitleText?: string;
        showAllProducts?: string;
        txtZeroResultsFound?: string;
        txtPageLoading?: string;
        txtSave?: string;
        txtCancel?: string;
        txtConfirm?: string;
        txtOther?: string;
        txtRemoveList?: string;
        txtshareArticleText?: string;
        txtshareLinkCopy?: string;
        txtInAppFacebookBrowserWarning?: string;
        TextInAppFacebookBrowserWarningChromeButton?: string;
        TextInAppFacebookBrowserWarningContinueButton?: string;
        txtOutdatedBrowserWarningTitle?: string;
        OutdatedBrowserWarningText?: string;
        OutdatedBrowserDontShow?: string;
        txtSelectAlternative?: string;
        
        //#endregion Util
        
        //#region Generic

        txtChooseCountry?: string;
        txtChooseLanguage?: string;
        txtCountryNL?: string;
        txtCountryBE?: string;
        txtCountryFR?: string;
        txtViewall?: string;
        txtPrice?: string;
        txtPriceFrom?: string;

        txtClose?: string;
        txtGoBack?: string;
        txtGoBackTo?: string;
        txtAdd?: string;
        txtRemoveAll?: string;

        txtSkip?: string;
        txtPrevious?: string;
        txtNext?: string;
        txtViewSelection?: string;

        priceFormat?: string;
        priceFormatWhole?: string;
        priceFormatCurrency?: string;
        priceSignAfter?: string;

        txtContinueShopping?: string;
        txtToOrderfunnel?: string;
        txtBackLowerCase?: string;
        txtToShoppingCart?: string;
        txtLookAtShoppingCart?: string;
        txtShoppingCartEmpty?: string;

        priceFree?: string;

        //#endregion Generic

        //#region Language popup

        langPopupTitle?: string;
        langPopupText?: string;

        //#endregion Language popup

        //#region Instagram

        beInspiredText?: string;

        //#endregion Instagram

        //#region Category

        txtFilter?: string;
        txtFilterOn?: string;

        txtMore?: string;
        txtShowMore?: string;
        txtShowLess?: string;
        txtReadMore?: string;

        txtFrom?: string;
        txtUntil?: string;

        txtActiveFilterMinPrice?: string;
        txtActiveFilterMaxPrice?: string;

        txtFirstSelectArticleGroup?: string;

        txtSearchFor?: string;

        explanationText?: string;
        filterResultText?: string;
        filterShowresultText?: string;
        txtFilterShowAllResult?: string;

        eraseFilterSingleText?: string;
        eraseFilterMultipleText?: string;
        eraseMobileFilterSingleText?: string;
        eraseMobileFilterMultipleText?: string;

        articleGroupsToCheck?: Array<string>;
        notAllowedForColors?: Array<string>;
        categoryName?: { [category: string] : string[]};
        txtSoldoutAlternativeButton?: string;
        propertiesToCheck?: Array<string>;
        propertyOptionsToAllow?: Array<string>;
        boolReplaceSearchResultInfoText?: boolean;

        //#endregion Category

        //#region PDP

        showProductText?: string;
        inCartText?: string;
        cartHeaderText?: string;
        ARStep1Instructions?: string;
        ARStep2Instructions?: string;
        ARStep3Instructions?: string;
        ARStep4Instructions?: string;
        ARStep4Note?: string;
        ARStep4Continue?: string;
        ARStep4CheckboxText?: string;
        ARStepExplanationSkipText?: string;
        SelectMaterialTxt?: string;
        SelectColorTxt?: string;
        SelectBottomSheetTxt?: string;
        SelectPillowProtectionTxt?: string;
        LowStockRemainingMessage?: string;
        CartButtonExpectedDelivery?: string;
        MakeChoicePopupTitle?: string;

        //#endregion PDP

        //#region Productcomparer

        prodCompPageUrl?: string;

        buttonTextOrder?: string;
        buttonTextUnavailable?: string;
        buttonTextRemove?: string;
        removeAllProductsText?: string;
        txtChooseDifferentMeasure?: string;
        txtMattressHeight?: string;
        txtMaterial?: string;
        txtMeasure?: string;
        txtColor?: string;
        txtAvailableColors?: string;
        txtProdCompMaxCompare?: string;

        useCurrentArticlesText?: string;
        useArticlesAboveText?: string;

        txtEmptySuggestions?: string;

        compareEmptyText?: string;
        compareArticlesText?: string;
        comparePluralTitleText?: string;
        compareSingularTitleText?: string;
        priceStartingAtText?: string;
        onlyShowDifferenceText?: string;

        prodCompMismatchText?: string;
        prodCompMismatchLocalTitle?: string;
        prodCompMismatchDbTitle?: string;
        txtAddWishlist?: string;

        //#endregion Productcomparer

        //#region Shoppingcart

        shoppingCartUrlLowerCaseTxt?: string;
        step2Url?: string

        //#endregion Shoppingcart

        //#region Orderprocess

        noSelectedDeliveryMethod?: string;
        noSelectedPaymentMethod?: string;

        noCashUPS?: string;
        noCashDHL?: string;
        pickupOptionText?: string;
        chooseDeliveryOrPickup?: string;
        choosePaymentOption?: string;
        pickupModalAddressOpeningTimes?: string;

        txtCountryPickupNotAvailable?: string;

        txtChangedDeliveryEstimateTo?: string;

        //#endregion Orderprocess

        //#region Password

        capslockWarningTxt?: string;
        minCharTxt?: string;
        maxCharTxt?: string;
        combinedMinMaxTxt?: string;
        reqDigitTxt?: string;
        reqCapitalTxt?: string;
        reqLowerCaseTxt?: string;
        reqSpecialCharactersTxt?: string;
        passwordRequirementsTxt?: string;
        forgottenPasswordTxt?: string;
        forgottenPasswordEmailSendTxt?: string;
        confirmPasswordTxt?: string

        //#endregion Password

        //#region Address suggestion

        addressNotFoundText?: string;
        addressNotFoundCheckAddressText?: string;
        addressNotFoundSuggestionText?: string;
        addressUseSuggestionText?: string;

        //#endregion Address suggestion

        //#region Phone validation

        phoneValidationInvalidCountryCode?: string;
        phoneValidationRequired?: string;
        phoneValidationTooShort?: string;
        phoneValidationTooLong?: string;
        phoneValidationError?: string;

        //#endregion Phone validation

        //#region Errors

        noCityName?: string;
        noStreetName?: string;
        noHouseNumber?: string;

        cityMandatory?: string;
        streetMandatory?: string;
        fieldMandatory?: string;
        prefrencesError?: string;

        rmaOrderNumberNotFoundError?: string;

        //#endregion Errors

        //#region Account

        prefrencesSaved?: string;
        emailTxt?: string,
        txtResetPassword?: string,
        txtMergeCarts?: string,
        txtAddAddress?: string,
        txtChangeAddress?: string,
        txtcheckEmailForHelpWithLogin?: string,

        //#endregion Account

        //#region Favorieten

        txtFavoritePopuptitle?: string;
        txtFavoritePopupsubtitle?: string;

        //#endregion Favorieten

        //#region Cookies

        txtCookiesPreferences?: string;
        txtCookiesTitle?: string;
        txtCookiesReject?: string;
        txtCookiesConfirm?: string;

        //#endregion

        //#region Phonenumber

        defaultCountry?: string;
        onlyCountries?: string[];
        countryNameTranslation?: Record<string, string>;

        //#endregion Phonenumber
    }

class TranslationSite
{
    languageCode: string;
    siteID?: number;
    translations: Translations;
}

const initTranslations = () =>
{
    //#region Dutch

    const nlTranslations: Translations =
    {
        //#region Util

        searchUrl: "/zoeken/",
        loginUrl: "/mijn-account/inloggen/winkelwagen/",
        txtUtilStep2: "/winkelwagen/stap-2/",
        txtUtilShoppingCart: "Winkelwagen",
        txtUtilHome: "Home",
        homeUrlLowerCaseTxt: "/home/",
        txtUtilSearch: "Zoeken",
        txtUtilShowCapitals: "TOON",
        txtUtilProductCapitals: "PRODUCT",
        txtUtilProductsCapitals: "PRODUCTEN",
        txtUtilShow: "Toon",
        txtUtilProduct: "product",
        txtUtilProducts: "producten",
        pageText: "Pagina ",
        pageTitleText: "Pagina {0}",
        pageNumberText: "Pagina {0}",
        indexPositionText: " van ",
        previousPageTitleText: "Vorige pagina",
        nextPageTitleText: "Volgende pagina",
        showAllProducts: "Toon alle producten",
        txtZeroResultsFound: "0 resultaten gevonden",
        txtPageLoading: "De pagina is aan het laden. Een moment geduld alsjeblieft.",
        txtSave: "Opslaan",
        txtCancel: "Annuleren",
        txtConfirm: "Bevestig",
        txtOther: "Anders...",

        txtRemoveList: "Weet je zeker dat je de lijst wilt verwijderen?",
        txtshareArticleText: "Ik wil een artikel met je delen",
        txtshareLinkCopy: "Link gekopieerd",
        txtInAppFacebookBrowserWarning: "Let op: je zit nog in de Facebook-app; onze website werkt hier mogelijk minder goed. Deze kan je winkelwagen niet bewaren als je deze later nog eens wilt openen.",
        TextInAppFacebookBrowserWarningChromeButton: "Open in Chrome",
        TextInAppFacebookBrowserWarningContinueButton: "doorgaan",
        txtOutdatedBrowserWarningTitle: "Je gebruikt een verouderde browser",
        OutdatedBrowserWarningText: "Open de website in een moderne browser voor de beste ervaring.",
        OutdatedBrowserDontShow: "melding niet meer tonen",

        //#endregion Util

        //#region Generic

        txtChooseCountry: "Selecteer je land",
        txtChooseLanguage: "Selecteer je taal",

        txtCountryNL: "Nederland",
        txtCountryBE: "België",
        txtCountryFR: "Frankrijk",

        txtViewall: "Bekijk alle",
        txtPrice: "Prijs",
        txtPriceFrom: "Vanaf",

        txtContinueShopping: "Verder winkelen",
        txtToOrderfunnel: "Verder naar bestellen",
        txtBackLowerCase: "terug",
        txtToShoppingCart: "Naar winkelwagen",
        txtLookAtShoppingCart: "Bekijk winkelwagen",
        txtShoppingCartEmpty: "Jouw winkelwagen is nog leeg",

        txtClose: "Sluiten",
        txtGoBack: "Terug",
        txtGoBackTo: "Terug naar ",
        txtAdd: "Toevoegen",
        txtRemoveAll: "Alles verwijderen",

        txtSkip: "Overslaan",
        txtPrevious: "Vorige",
        txtNext: "Volgende",
        txtViewSelection: "BEKIJK SELECTIE",

        priceFormat: "{1},{2}",
        priceFormatWhole: "{1},-",
        priceFormatCurrency: "",
        priceSignAfter: ",-",

        priceFree: "Gratis",

        txtSelectAlternative: "Selecteer alternatief",

        //#endregion Generic

        //#region Language popup

        langPopupTitle: "Hoe wil jij winkelen?",
        langPopupText: "Je ziet alleen artikelen en promoties die beschikbaar zijn in het land dat je kiest. Verkoopprijzen kunnen verschillen per land. Aanpassen kan altijd weer.",

        //#endregion Language popup

        //#region Instagram

        beInspiredText: "Laat je inspireren",

        //#endregion Instagram

        //#region Category

        txtFilter: "Filter",
        txtFilterOn: "Filter op",

        txtMore: "Meer",
        txtShowMore: "Meer tonen",
        txtShowLess: "Minder tonen",
        txtReadMore: "Lees meer",

        txtFrom: "Vanaf",
        txtUntil: "Tot",

        txtActiveFilterMinPrice: "Prijs vanaf",
        txtActiveFilterMaxPrice: "Prijs tot",
        txtFirstSelectArticleGroup: "Selecteer eerst een artikelgroep",

        txtSearchFor: "Zoek op",

        explanationText: "Uitleg",
        filterResultText: "Toon {0} resultaten",
        filterShowresultText: "Toon resultaten",
        txtFilterShowAllResult: "Toon alle resultaten",

        eraseFilterSingleText: "Filter wissen",
        eraseFilterMultipleText: "Filters wissen",
        eraseMobileFilterSingleText: "Filter wissen",
        eraseMobileFilterMultipleText: "Filters wissen",

        articleGroupsToCheck: ["Bedsprei", "Dekbed", "Dekbedovertrek", "Dubbele split hoeslaken", "Hoeslaken", "Laken", "Matrasbeschermer", "Noppenmatras", "Onderdeken", "Partnerdekbed", "Split hoeslaken", "Split matrasbeschermer"],
        notAllowedForColors: ["Dekbed", "Matrasbeschermer", "Noppenmatras", "Onderdeken", "Partnerdekbed", "Split matrasbeschermer", "Hoofdkussen"],
        // id: data-category from productdata, first string: display, second string: href url
        categoryName: {
            ["Dekbedovertrek"]: ["dekbedovertrekken", "dekbedovertrek"],
            ["Dekbed"]: ["dekbedden", "dekbed"],
            ["Hoeslaken"]: ["hoeslakens", "laken-sloop"],
            ["Matrasbeschermer"]: ["matrasbeschermers", "laken-sloop/matrasbeschermer/"],
            ["Split hoeslaken"]: ["split hoeslakens", "laken-sloop/split-hoeslaken/"],
            ["Noppenmatras"]: ["noppenmatrassen", "laken-sloop/noppenmatras/"],
            ["Kussenbeschermer"]: ["kussenbeschermers", "hoofdkussen/kussenbeschermer/"],
            ["Molton"]: ["moltons", "laken-sloop/molton"],
            ["Split molton"]: ["split moltons", "laken-sloop/split-molton/"],
            ["Kussensloop"]: ["kussenslopen", "hoofdkussen/kussensloop"],
            ["Laken"]: ["lakens", "laken-sloop/laken"],
            ["Dekbed zonder overtrek"]: ["dekbedden zonder overtrek", "dekbed/dekbed-zonder-overtrek/"],
            ["Hoofdkussen"]: ["hoofdkussens", "hoofdkussen"],
            ["Plaid"]: ["plaids", "plaid"],
            ["Bedsprei"]: ["bedspreien", "bedsprei"],
            ["Deken"]: ["dekens", "deken"],
            ["Washandje"]: ["washandjes", "badtextiel/washandje"],
            ["Gastendoekje"]: ["gastendoekjes", "badtextiel/gastendoekje"],
            ["Douchelaken"]: ["douchelakens", "badtextiel/douchlaken"],
            ["Handdoek"]: ["handdoeken", "badtextiel/handdoek"],
            ["Badlaken"]: ["badlakens", "badtextiel/badlaken"],
            ["Badmat"]: ["badmatten", "badtextiel/badmat"],
            ["Strandlaken"]: ["strandlakens", "strandlaken"],
            ["Hamamdoek"]: ["hamamdoeken", "strandlaken/hamamdoek"],
            ["Keukendoek"]: ["keukendoeken", "keukentextiel/keukendoek"],
            ["Theedoek"]: ["theedoeken", "keukentextiel/thedoek"],
        },
        txtSoldoutAlternativeButton: "Bekijk alternatieve {0}",
        propertiesToCheck: ["5"],
        propertyOptionsToAllow: ["2"],
        boolReplaceSearchResultInfoText: false,

        //#endregion Category

        //#region PDP

        showProductText: "Bekijk",
        inCartText: "In winkelwagen",
        cartHeaderText: "Toegevoegd aan winkelwagen",
        ARStep1Instructions: "Richt je telefoon op je bed en een deel van de vloer. Houd enkele meters afstand.",
        ARStep2Instructions: "Gebruik één vinger om het dekbedovertrek te verplaatsen.",
        ARStep3Instructions: "Gebruik twee vingers om het dekbedovertrek te vergroten/verkleinen en te draaien.",
        ARStep4Instructions: "Er wordt een 3D-model gedownload om het product te kunnen projecteren via je camera.",
        ARStep4Note: "Kleuren kunnen in het echt afwijken.",
        ARStep4Continue: "Ga verder",
        ARStep4CheckboxText: "Niet meer laten zien",
        ARStepExplanationSkipText: "uitleg overslaan",
        SelectMaterialTxt: "Selecteer je materiaal",
        SelectColorTxt: "Selecteer je kleur",
        SelectBottomSheetTxt: "Selecteer een hoeslaken",
        SelectPillowProtectionTxt: "Selecteer je kussenbeschermer",
        LowStockRemainingMessage: "Nog maar enkele beschikbaar",
        CartButtonExpectedDelivery: "Bestel nu, verwachte levering {0}",
        MakeChoicePopupTitle: "Maak een keuze",

        //#endregion PDP

        //#region Productcomparer

        prodCompPageUrl: "/vergelijk/",

        buttonTextOrder: "Bestellen",
        buttonTextUnavailable: "Niet beschikbaar",
        buttonTextRemove: "Verwijderen",
        removeAllProductsText: "Wis product(en)",
        txtChooseDifferentMeasure: "Kies andere maat",
        txtMattressHeight: "Matrashoogte",
        txtMaterial: "Materiaal",
        txtMeasure: "Maat",
        txtColor: "Kleur",
        txtAvailableColors: "Beschikbare kleuren",
        txtProdCompMaxCompare: `Je kunt maximaal ${shopConfig().productCompareMaxCount} producten vergelijken.`,

        useCurrentArticlesText: "Huidige lijst gebruiken",
        useArticlesAboveText: "Bovenstaande artikelen gebruiken",

        txtEmptySuggestions: "Op zoek naar ideeën?",

        compareEmptyText: "De vergelijker is op dit moment leeg",
        compareArticlesText: "Vergelijk artikelen",
        comparePluralTitleText: "Producten vergelijken",
        compareSingularTitleText: "Vergelijken",
        priceStartingAtText: "vanaf",
        onlyShowDifferenceText: "Alleen de verschillen tonen",

        prodCompMismatchText: "Er stonden nog producten in de winkelwagen van je vorige bezoek. Wat wil je doen?",
        prodCompMismatchLocalTitle: "Huidige lijst",
        prodCompMismatchDbTitle: "Van je laatste bezoek",

        txtAddWishlist: "Op verlanglijst",

        //#endregion Productcomparer

        //#region Shoppingcart

        shoppingCartUrlLowerCaseTxt: "/winkelwagen/",
        step2Url: "/winkelwagen/stap-2/",

        //#endregion Shoppingcart

        //#region Orderprocess

        noSelectedDeliveryMethod: "Je hebt geen leveringsmethode geselecteerd.",
        noSelectedPaymentMethod: "Je hebt geen betaalmethode geselecteerd.",

        noCashUPS: "Je kunt niet contant betalen bij afhalen op een UPS-punt.",
        noCashDHL: "Je kunt niet contant betalen bij afhalen op een DHL-locatie.",
        pickupOptionText: "Afhalen op een afhaalpunt",
        chooseDeliveryOrPickup: "Kies voor bezorgen of afhalen.",
        choosePaymentOption: "Kies een betaalmethode.",
        pickupModalAddressOpeningTimes: "Adres/openingstijden:",

        txtCountryPickupNotAvailable: "Er zijn helaas geen afhaalpunten beschikbaar in dit land.",

        txtChangedDeliveryEstimateTo: "De verwachte bezorgtijd is aangepast naar: {0}",

        //#endregion Orderprocess

        //#region Password

        capslockWarningTxt: "Opgelet! CAPS LOCK is aan",
        minCharTxt: "Minimaal {0} karakters",
        maxCharTxt: "Maximaal {0} karakters",
        combinedMinMaxTxt: "Lengte tussen de 8 en 20 tekens",
        reqDigitTxt: "Minimaal 1 cijfer",
        reqCapitalTxt: "Minimaal 1 hoofdletter",
        reqLowerCaseTxt: "Minimaal 1 kleine letter",
        reqSpecialCharactersTxt: "Minimaal {0} speciaal teken (!@#$)",
        passwordRequirementsTxt: "Wachtwoord eisen",
        forgottenPasswordTxt: "Wachtwoord vergeten?",
        forgottenPasswordEmailSendTxt: "Indien het e-mailadres bestaat is er een e-mail met de stappen om het wachtwoord te herstellen verstuurd",
        confirmPasswordTxt: "Wachtwoorden moeten overeen komen",

        //#endregion Password

        //#region Address suggestion

        addressNotFoundText: "Adres niet gevonden",
        addressNotFoundCheckAddressText: "Adres niet gevonden, controleer je gegevens.",
        addressNotFoundSuggestionText: "Adres niet gevonden, bedoel je:<br/>{0} {1}, {2}?",
        addressUseSuggestionText: "Adres overnemen",

        //#endregion Address suggestion

        //#region Phone validation

        phoneValidationInvalidCountryCode: "Landcode is onjuist, controleer de landselectie.",
        phoneValidationRequired: "Telefoonnummer is verplicht",
        phoneValidationTooShort: "Het nummer is te kort, controleer het nummer.",
        phoneValidationTooLong: "Het nummer is te lang, controleer het nummer.",
        phoneValidationError: "Het telefoonnummer is ongeldig, controleer het nummer.",

        //#endregion Phone validation

        //#region Errors

        noCityName: "",
        noStreetName: "",
        noHouseNumber: "",

        cityMandatory: "Er is geen plaats ingevuld.",
        streetMandatory: "Er is geen straat ingevuld.",
        fieldMandatory: "Dit veld is verplicht.",
        prefrencesError: "Voorkeuren opslaan mislukt.",

        rmaOrderNumberNotFoundError: "Het opgegeven nummer is helaas niet gevonden. Zie de voorbeelden hierboven voor het juiste aantal letters en/of cijfers.",

        //#endregion Errors

        //#region Account

        prefrencesSaved: "Je voorkeuren zijn opgeslagen.",
        emailTxt: "E-mailadres",
        txtResetPassword: "Reset wachtwoord",
        txtMergeCarts: "Winkelwagen samenvoegen",
        txtAddAddress: "Adres toevoegen",
        txtChangeAddress: "Adres wijzigen",
        txtcheckEmailForHelpWithLogin: "We hebben je een mail gestuurd om direct in te loggen. Controleer je mailbox!",

        //#endregion Account

        //#region Favorieten

        txtFavoritePopuptitle: "Favoriet toevoegen",
        txtFavoritePopupsubtitle: "Kies een lijst waar je dit product aan toe wilt voegen",

        //#endregion Favorieten

        //#region Cookies

        txtCookiesPreferences: "Voorkeuren kiezen",
        txtCookiesConfirm: "Keuze opslaan",
        txtCookiesReject: "Afwijzen",
        txtCookiesTitle: "Cookiemelding",

        //#endregion Cookies

        //#region Phonenumber

        defaultCountry: "NL",
        onlyCountries: ['NL', 'BE', 'DE', 'FR', 'LU', 'AT', 'ES'],
        countryNameTranslation: { 'nl': 'Nederland', 'be': 'België', 'de': 'Duitsland', 'fr': 'Frankrijk', 'lu': 'Luxemburg', 'at': 'Oostenrijk', 'es': 'Spanje' }

        //#endregion Phonenumber
    };

    translationList.push({ languageCode: "NL", siteID: null, translations: nlTranslations });

    //#endregion Dutch

    const beNlTranslation: Translations = {
        //#region Phonenumber

        defaultCountry: "BE",
        onlyCountries: ['NL', 'BE', 'DE', 'FR', 'LU', 'AT', 'ES'],
        countryNameTranslation: { 'nl': 'Nederland', 'be': 'België', 'de': 'Duitsland', 'fr': 'Frankrijk', 'lu': 'Luxemburg', 'at': 'Oostenrijk', 'es': 'Spanje' }

        //#endregion Phonenumber
    };

    const beFRTranslation: Translations = {
        //#region Phonenumber

        defaultCountry: "BE",
        onlyCountries: ['NL', 'BE', 'DE', 'FR', 'LU', 'AT', 'ES'],
        countryNameTranslation: { 'nl': 'Pays-Bas', 'be': 'Belgique', 'de': 'Duitsland', 'fr': 'France', 'lu': 'Luxemburg', 'at': 'Oostenrijk', 'es': 'Spanje' }

        //#endregion Phonenumber
    };

    //#region French

    const frTranslation: Translations = {
        searchUrl: "/recherche/",
        loginUrl: "/mon-compte/connexion/panier/",
        txtUtilStep2: "/panier/etape-2/",
        txtUtilShoppingCart: "Panier",
        txtUtilHome: "Accueil",
        homeUrlLowerCaseTxt: "/page-d-accueil/",
        txtUtilSearch: "Recherche",
        txtUtilShowCapitals: "AFFICHEZ",
        txtUtilProductCapitals: "PRODUIT",
        txtUtilProductsCapitals: "PRODUITS",
        txtUtilShow: "Affichez",
        txtUtilProduct: "Produit",
        txtUtilProducts: "Produits",
        pageText: "Page ",
        pageTitleText: "Page {0}",
        pageNumberText: "Page {0}",
        indexPositionText: " sur ",
        previousPageTitleText: "Page précédente",
        nextPageTitleText: "Page suivante",
        showAllProducts: "Voir tout",
        txtZeroResultsFound: "Supprimez les filtres",
        txtPageLoading: "La page est en cours de chargement. Veuillez patienter",
        txtSave: "Sauvegarder",
        txtCancel: "Annuler",
        txtConfirm: "Confirmer",
        txtOther: "Sinon...",
        txtRemoveList: "Etes-vous sûr(e) de vouloir supprimer la liste ?",
        txtshareArticleText: "Je veux partager cet article avec toi",
        txtshareLinkCopy: "Lien copié",
        txtInAppFacebookBrowserWarning: "Attention : comme cette page est ouverte à partir de l'application Facebook, notre site web risque de moins bien fonctionner. Nous ne serons pas en mesure de sauvegarder votre panier pour le récupérer plus tard.",
        TextInAppFacebookBrowserWarningChromeButton: "Ouvrir dans Chrome",
        TextInAppFacebookBrowserWarningContinueButton: "Continuer",
        txtOutdatedBrowserWarningTitle: "Votre navigateur n'est plus à jour",
        OutdatedBrowserWarningText: "Afin de profiter de la meilleure expérience sur notre site, nous vous recommandons de passer à un navigateur plus récent.",
        OutdatedBrowserDontShow: "ne plus afficher de notification",
        txtChooseCountry: "Choisissez votre pays",
        txtChooseLanguage: "Choisissez votre langue",
        txtCountryNL: "Les Pays-Bas",
        txtCountryBE: "Belgique",
        txtCountryFR: "France",
        txtViewall: "Afficher tout",
        txtPrice: "Prix",
        txtPriceFrom: "À partir de ",
        txtClose: "Fermer",
        txtGoBack: "Retour",
        txtGoBackTo: "Retour vers ",
        txtAdd: "Ajouter",
        txtRemoveAll: "Supprimer tout",
        txtSkip: "Passer",
        txtPrevious: "Dernier",
        txtNext: "Suivant",
        txtViewSelection: "Voir sélection",
        priceFormat: "{1},{2} {0}",
        priceFormatWhole: "{1} {0}",
        priceFormatCurrency: "€",
        priceSignAfter: " €",
        txtContinueShopping: "Continuer vos achats",
        txtToOrderfunnel: "Procèder à la commande",
        txtBackLowerCase: "Retour",
        txtToShoppingCart: "Voir mon panier",
        txtLookAtShoppingCart: "Voir mon panier",
        txtShoppingCartEmpty: "Votre panier est encore vide.",
        priceFree: "Gratuit",
        txtSelectAlternative: "Sélectionner une alternative",
        langPopupTitle: "Comment voulez-vous naviguer sur notre site ?",
        langPopupText: "Seuls les produits et les offres disponibles dans le paus choisi sont affichés. Le prix d'achat peut varier d'un pays à l'autre. Vous pouvez à tout moment adapter vos choix",
        beInspiredText: "Laissez-vous inspirer",
        txtFilter: "Filtrer",
        txtFilterOn: "Filtrer par",
        txtMore: "plus",
        txtShowMore: "Voir plus",
        txtShowLess: "Voir moins",
        txtReadMore: "En savoir plus",
        txtFrom: "À partir de ",
        txtUntil: "Jusqu'à ce que ",
        txtActiveFilterMinPrice: "À partir de ",
        txtActiveFilterMaxPrice: "Jusqu'à ce que ",
        txtFirstSelectArticleGroup: "Sélectionnez article",
        txtSearchFor: "Saisir",
        explanationText: "Info",
        filterResultText: "Voir les {0} résultats",
        filterShowresultText: "",
        txtFilterShowAllResult: "Afficher tous les résultats",
        eraseFilterSingleText: "Supprimer filtre",
        eraseFilterMultipleText: "Supprimer filtres",
        eraseMobileFilterSingleText: "Supprimez",
        eraseMobileFilterMultipleText: "Supprimez",
        articleGroupsToCheck: [],
        notAllowedForColors: ["Dekbed", "Matrasbeschermer", "Noppenmatras", "Onderdeken", "Partnerdekbed", "Split matrasbeschermer", "Hoofdkussen"],
        categoryName: {
            ["Dekbedovertrek"]: ["housses de couette", "housse-de-couette/"],
            ["Dekbed"]: ["couettes", "couette"],
            ["Hoeslaken"]: ["draps-housses", "drap-taie"],
            ["Matrasbeschermer"]: ["protège-matelas", "drap-taie/protege-matelas/"],
            ["Molton"]: ["drap-housse molleton", "drap-taie/molleton/"],
            ["Split hoeslaken"]: ["Drap-housse tête relevable", "drap-taie/drap-housse-tete-relevable/"],
            ["Noppenmatras"]: ["noppenmatrassen", "laken-sloop/noppenmatras/"],
            ["Kussenbeschermer"]: ["protège oreiller", "oreiller/protege-oreiller/"],
            ["Split molton"]: ["drap-housse molleton tête relevable", "drap-taie/molleton-tete-relevable/"],
            ["Kussensloop"]: ["taie d’oreiller", "oreiller/taie/"],
            ["Laken"]: ["draps", "drap-taie/drap/"],
            ["Dekbed zonder overtrek"]: ["couette sans housse", "couette/couette-sans-housse/"],
            ["Hoofdkussen"]: ["oreiller", "oreiller/"],
            ["Plaid"]: ["plaids", "plaid"],
            ["Bedsprei"]: ["couvre lits", "couvre-lit/"],
            ["Deken"]: ["couverture", "couverture/"],
            ["Washandje"]: ["gant de toilette", "linge-de-bain/gant-de-toilette/"],
            ["Gastendoekje"]: ["Serviettes d’invité", "linge-de-bain/serviette-dinvite/"],
            ["Douchelaken"]: ["serviette de douche", "linge-de-bain/serviette-de-douche/"],
            ["Handdoek"]: ["serviette", "linge-de-bain/serviette/"],
            ["Badlaken"]: ["serviette de bain", "linge-de-bain/serviette-de-bain/"],
            ["Badmat"]: ["tapis de bain", "linge-de-bain/tapis-de-bain/"],
            ["Strandlaken"]: ["serviettes de plage", "serviette-de-plage"],
            ["Hamamdoek"]: ["fouta", "serviette-de-plage/fouta/"],
            ["Keukendoek"]: ["essuie-mains", "textile-de-cuisine/essuie-mains/"],
            ["Theedoek"]: ["torchon", "textile-de-cuisine/torchon/"],
        },
        txtSoldoutAlternativeButton: "Voir les autres {0}",
        propertiesToCheck: [],
        propertyOptionsToAllow: [],
        boolReplaceSearchResultInfoText: true,
        showProductText: "Voir produit",
        inCartText: "Ajouter au panier",
        cartHeaderText: "Ajouté au panier",
        ARStep1Instructions: "Visez votre lit et une partie du sol avec votre smartphone. Gardez une distance de quelques mètres du sujet.",
        ARStep2Instructions: "Utilisez l’index pour déplacer la représentation virtuelle de la housse de couette.",
        ARStep3Instructions: "Utilisez le pouce et l’index pour agrandir/rétrécir ou faire pivoter la représentation virtuelle de la housse de couette.",
        ARStep4Instructions: "Un modèle 3D sera téléchargé pour permettre la visualisation de la housse de couette par votre smartphone.",
        ARStep4Note: "Les couleurs présentées peuvent différer de la réalité.",
        ARStep4Continue: "Continuer",
        ARStep4CheckboxText: "Ne plus afficher ce message",
        ARStepExplanationSkipText: "ignorer l'explication",
        SelectMaterialTxt: "Choisissez votre matière",
        SelectColorTxt: "Choisissez votre couleur",
        SelectBottomSheetTxt: "Choisissez votre drap-housse",
        SelectPillowProtectionTxt: "Choisissez votre protège-oreiller",
        LowStockRemainingMessage: "Quantités limitées",
        CartButtonExpectedDelivery: "Commandez, livraison prévue le {0}",
        MakeChoicePopupTitle: "Veuillez choisir",
        prodCompPageUrl: "/comparer/",
        buttonTextOrder: "Je commander",
        buttonTextUnavailable: "Indisponible",
        buttonTextRemove: "Supprimer produit",
        removeAllProductsText: "Supprimer produits",
        txtChooseDifferentMeasure: "Autre taille",
        txtMattressHeight: "Epaisseur de matelas",
        txtMaterial: "Matière",
        txtMeasure: "Taille",
        txtColor: "Couleur",
        txtAvailableColors: "Couleurs disponibles",
        txtProdCompMaxCompare: `Vous pouvez comparer un maximum de ${shopConfig().productCompareMaxCount} produits.`,
        useCurrentArticlesText: "Utiliser votre liste actuel",
        useArticlesAboveText: "Récupérer les articles de votre dernière visite",
        txtEmptySuggestions: "Besoin d'inspiration&nbsp;?",
        compareEmptyText: "Il n'y a aucun produit dans votre comparateur",
        compareArticlesText: "Comparer produits",
        comparePluralTitleText: "Comparer",
        compareSingularTitleText: "Comparer",
        priceStartingAtText: "À partir de ",
        onlyShowDifferenceText: "Afficher uniquement les différences",
        prodCompMismatchText: "Des articles vous attendent dans le panier de votre dernière visite. Que voulez-vous faire?",
        prodCompMismatchLocalTitle: "Liste actuel",
        prodCompMismatchDbTitle: "De votre dernière visite",
        txtAddWishlist: "Ajouter à mes favoris",
        shoppingCartUrlLowerCaseTxt: "/panier/",
        step2Url: "/panier/etape-2/",
        noSelectedDeliveryMethod: "Vous n'avez sélectionné aucun mode de livraison.",
        noSelectedPaymentMethod: "Vous n'avez sélectionné aucun mode de paiement.",
        noCashUPS: "En cas de retrait en point relais UPS, vous ne pouvez pas sélectionner le mode de paiement au comptant.",
        noCashDHL: "En cas de retrait en point relais DHL, vous ne pouvez pas sélectionner le mode de paiement au comptant.",
        pickupOptionText: "Livraison en point relais",
        chooseDeliveryOrPickup: "Choisir enlèvement ou livraison.",
        choosePaymentOption: "Sélectionnez votre mode de paiement.",
        pickupModalAddressOpeningTimes: "Adresse/horaires d'ouvertures",
        txtCountryPickupNotAvailable: "Malheureusement, aucun point de retrait n'est disponible dans le pays choisi",
        txtChangedDeliveryEstimateTo: "La date de livraison estimée a été modifiée {0}",
        capslockWarningTxt: "Attention ! CAPS LOCK enclenchén",
        minCharTxt: "Au moins {0} caractères",
        maxCharTxt: "Maximum {0} caractères",
        combinedMinMaxTxt: "Le mot de passe doit contenir au moins 8 caractères et pas plus de 20",
        reqDigitTxt: "Au moins 1 chiffre",
        reqCapitalTxt: "Au moins 1 lettre majuscule",
        reqLowerCaseTxt: "Au moins 1 lettre minuscule",
        reqSpecialCharactersTxt: "Au moins 1 caractère spécial (!@#$)",
        passwordRequirementsTxt: "Le mot de passe doit contenir ",
        forgottenPasswordTxt: "Vous avez oublié votre mot de passe?",
        forgottenPasswordEmailSendTxt: "Un email vous a été envoyé à l’adresse jve@estrategy.nl. Il contient des instructions pour réinitialiser votre mot de passe.",
        confirmPasswordTxt: "Les mots de passe doivent correspondre",
        addressNotFoundText: "Adresse non trouvée",
        addressNotFoundCheckAddressText: "Adresse non trouvée, vérifiez vos coordonnées.",
        addressNotFoundSuggestionText: "Adresse non trouvée, vous voulez dire&nbsp;:<br/>{0} {1}, {2}?",
        addressUseSuggestionText: "Reprendre cette adresse",
        phoneValidationInvalidCountryCode: "Le code pays est incorrect, veuillez vérifier la sélection du pays.",
        phoneValidationRequired: "Le numéro de téléphone n'est pas valide, veuillez vérifier le numéro.",
        phoneValidationTooShort: "Le numéro est trop court, vérifiez le numéro.",
        phoneValidationTooLong: "Le numéro est trop long, vérifiez le numéro.",
        phoneValidationError: "Le numéro de téléphone n'est pas valide, veuillez vérifier le numéro.",
        noCityName: "Le champs Ville n'est pas rempli",
        noStreetName: "Le champs Rue n'est pas rempli.",
        noHouseNumber: "Aucun numéro de rue n'a été saisi.",
        cityMandatory: "Ville est obligatoire.",
        streetMandatory: "Rue est obligatoire.",
        fieldMandatory: "Ce champ est obligatoire.",
        txtMergeCarts: "Fusionner le panier d'achat",
        txtAddAddress: "Ajouter nouvelle adresse",
        txtChangeAddress: "Modifier l'adresse",
        txtcheckEmailForHelpWithLogin: "Consultez votre courrier électronique pour obtenir de l'aide pour vous connecter.",
        txtFavoritePopuptitle: "Sauvegarder, gérer ou partager ses favoris avec sa famille ou ses amis ?",
        txtFavoritePopupsubtitle: "Choisissez la liste à laquelle vois souhaitez ajouter ce produit",
        prefrencesError: "L'enregistrement des préférences a échoué",
        rmaOrderNumberNotFoundError: "Le numéro que vous avez saisi n'est pas valide. Veuillez vérifier si le nombre de lettres et/ou de chiffres est exact, en vous référant aux exemples ci-dessus.",
        prefrencesSaved: "Vos préférences ont été enregistrées",
        txtResetPassword: "Réinitialiser le mot de passe",
        emailTxt: "Adresse e-mail",
        txtCookiesPreferences: "Personnaliser",
        txtCookiesConfirm: "Sauvegarder",
        txtCookiesReject: "Tout refuser",
        txtCookiesTitle: "Utilisation des cookies",

        //#region Phonenumber

        defaultCountry: "FR",
        onlyCountries: ['NL', 'BE', 'DE', 'FR', 'LU', 'AT', 'ES'],
        countryNameTranslation: { 'nl': 'Pays-Bas', 'be': 'Belgique', 'de': 'Duitsland', 'fr': 'France', 'lu': 'Luxemburg', 'at': 'Oostenrijk', 'es': 'Spanje' }

        //#endredion Phonenumber
    }

    translationList.push({ languageCode: "FR", siteID: null, translations: frTranslation });

    //#endregion
};

initTranslations();

let currentSiteTranslations: Translations = null;

const getTranslations = () =>
{
    if (!currentSiteTranslations)
    {
        const siteTranslationList = translationList.find(t => t.siteID === shopConfig().currentSiteID);
        if (siteTranslationList)
        {
            const siteTranslations = siteTranslationList.translations;
            const countryTranslations = translationList.find(t => t.languageCode === langCode && t.siteID == null).translations;
            currentSiteTranslations = createTranslationProxy(siteTranslations, countryTranslations);
        }
        else
            currentSiteTranslations = translationList.find(t => t.languageCode === langCode && t.siteID == null).translations;
    }

    return currentSiteTranslations;
};

const createTranslationProxy = (primary: Translations, fallback: Translations): Translations =>
{
    return new Proxy(primary, {
        get(target, prop)
        {
            const value = target[prop as keyof Translations];
            if (value !== undefined && value !== null)
            {
                return value;
            }
            return fallback[prop as keyof Translations];
        }
    });
}

(window as any).getTranslations = getTranslations;

export { menuAccountItems, getTranslations };
